



































































































































import {computed, defineComponent, onMounted, reactive, ref, getCurrentInstance} from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue';
import Edit from "./edit.vue";
import request from '@/utils/request';
import waves from '@/directive/waves'
import Import from './import.vue';
import AddCart from '@/components/AddCart/index.vue';
import {Message} from 'element-ui'

export default defineComponent({
  name: 'inventoryQuery',
  components: {PageWrapper, Edit, Import, AddCart},
  directives: {waves},
  setup() {
    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const searchFormRef = ref(null)
    const searchForm = reactive({
      title: '',
      xhname: '',
      source: '',
      gongyingshang: '',
      stock_filter: ''
    })
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20,
    })
    const allNum = ref(1)
    const dialog = ref(false)
    const type = ref("")
    const editFormData = ref({})
    const list = ref([])
    const listLoading = ref(false)
    const untaxedAmount = ref(0)
    const taxedAmount = ref(0)
    const exportLoading = ref(false)
    const importLoading = ref(false)
    const keyId = ref(0)
    const submitLoading = ref(false)
    const dialogImport = ref(false)
    const filterNum = ref([
      {
        label: '大于0',
        value: 'gt0',
      },
      {
        label: '全部',
        value: 'all'
      }
    ])
    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    //获取库存列表
    const getInventoryQuery = () => {
      listLoading.value = true
      request({
        url: 'inventory_list.yy',
        method: 'post',
        params: selectPage,
        data: {...searchForm,username: username},
      }).then(res => {
        const {code, data1, data2, total,num} = res
        if (code == 200) {
          listLoading.value = false
          list.value = data2
          untaxedAmount.value = data1[0].wshui_amount
          taxedAmount.value = data1[0].hshui_amount
          allNum.value = total
          addedNum.value = num
        }
      })
    }

    onMounted(() => {
      getInventoryQuery()
    })

    //新增购物车
    const handleAdd = () => {
      dialog.value = true;
      type.value = "add";
      editFormData.value = {}
    }
    //分页
    const pageSizeChange = (e: number) => {
      selectPage.pageSize = e
      getInventoryQuery()
    }
    const pageCurrentChange = (e: number) => {
      selectPage.pageNum = e
      getInventoryQuery()
    }
    //编辑
    const handleEdit = (scope) => {
      dialog.value = true
      type.value = "edit"
      editFormData.value = {...editFormData.value, ...scope.row}
      keyId.value = scope.row.id
    }
    //新增和编辑提交
    const handleSubmit = (form: Record<string, any>) => {
      let data:any;
      submitLoading.value = true
      if (type.value === 'add') {
        data = request({
          url: 'inventory_add.yy',
          method: 'post',
          data: form
        })
      } else {
        data = request({
          url: 'inventory_update.yy',
          method: 'post',
          data: {id: keyId.value, ...form}
        })
      }
      data.then(res => {
        if (res.code == 200) {
          submitLoading.value = false
          dialog.value = false
          getInventoryQuery()
        }
      })
    }

    //新增/编辑弹窗关闭
    const handleClose = () => {
      dialog.value = false
      editFormData.value = {}
    }


    const closeSearch = () => {
      showAll.value = !showAll.value
    }
    //搜索
    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getInventoryQuery()
    }
    //重置
    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getInventoryQuery()
    }
    //删除
    const handleDelete = ({type}, scope, index) => {
      request({
        url: 'inventory_delete.yy',
        method: 'post',
        data: {id: type === 'single' ? scope.row.id : selectId.value}
      }).then(res => {
        if (res.code == 200) deleteRow({type}, index)
      })
    }

    const deleteRow = ({type}, index) => {
      if (type === 'single') {
        list.value.splice(index, 1)
      } else {
        const idsToDelete = selectId.value.map(row => row);
        list.value = list.value.filter(item => !idsToDelete.includes(item.id));
      }
    }

    //导出excel，且格式化数据
    const formatJson = (data: any[], filterVal: string[]) => {
      const newList = JSON.parse(JSON.stringify(data))
      newList.forEach((item) => {
        if (item.spzt == 0) {
          item.spzt = '未税'
        } else if (item.spzt == 1) {
          item.spzt = '已到'
        } else {
          item.spzt = '未到'
        }
        if (item.zt == 1) {
          item.zt = '开放'
        } else {
          item.zt = '锁定'
        }
      })
      return newList.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
    const handleExport = () => {
      exportLoading.value = true
      request({
        url: 'inventory_download.yy',
        method: 'post',
        data: searchForm
      }).then(res => {
        if (res.code == 200) {
          import('@/vendor/Export2Excel').then(excel => {
            const tHeader = ['商品编码', '商品名称', '型号', '品牌', '库存数量', '未税价格', '含税价格',
              '零售价', '自定义价格', '收票状态', '产地', '包装', '库房货位', '进货日期', '供应商', '合同状态'
            ]
            const filterVal = ['id', 'title', 'xhname', 'source', 'number', 'wshui',
              'hshui', 'retail_price', 'zdyprice', 'spzt', 'address', 'baozhuang', 'kufang', 'settime', 'gongyingshang', 'zt'
            ]
            const data = formatJson(res.data, filterVal);
            (excel.export_json_to_excel as any)({
              header: tHeader,
              data,
              filename: '库存列表'
            });
            exportLoading.value = false
          })
        }
      })
    }

    //导入
    const handleImport = () => {
      dialogImport.value = true
    }

    //导入弹窗关闭
    const handleImportClose = () => {
      dialogImport.value = false
    }

    //上传成功后弹窗关闭
    const handleUpload = () => {
      dialogImport.value = false
      getInventoryQuery()
    }

    //批量选中的值
    const selectId = ref<string[]>()
    const handleSelectionChange = (val) => {
      selectId.value = val.map(item => item.id)
    }

    //添加功能
    const addedData = ref([])//已添加的数据
    const addedNum = ref(0)//已添加条数
    const drawerVisible = ref(false) //控制已添加数据弹窗
    //列表每行添加数据
    const handleAddXname = () => {
      drawerVisible.value = true
      request({
        url: 'member_add_cart.yy',
        method: 'post',
        data: {
          channel: 1,
          username: username
        }
      }).then(res => {
        addedData.value = res.cartlist
      })
    }

    const disabledIndexes = ref([])//添加完按钮禁用
    //已添加列表展disabledIndexes示
    const addToDrawer = (row, channel, index: number) => {
      if (!disabledIndexes.value.includes(row.id)) {
        disabledIndexes.value.push(row.id);
      }
      drawerVisible.value = true
      request({
        url: 'member_add_cart.yy',
        method: 'post',
        data: {
          id: row.id,
          username: username,
          channel: channel   //channel 1 库存列表  2 海外库存
        }
      }).then(res => {
        const {code, msg} = res
        addedData.value = res.cartlist
        if (code == 200) {
          Message.success(msg)
        } else if (code == 300) {
          Message.warning(msg)
        } else if (code == 400) {
          Message.error(msg)
        }
      })
    }
    //购物车关闭
    const handleCloseAddCart = () => {
      drawerVisible.value = false
    }

    //购物车单个删除
    const removeFromDrawer = (id: number) => {
      const result = disabledIndexes.value.map(item => Number(item.replace(/^No0+/, '')));
      disabledIndexes.value = result.filter(item => item !== id);
      getInventoryQuery()
    }

    //全部删除
    const handleClear = (items: Array<{ id: number }>) => {
      const ids = items.map(item => item.id);
      const result = disabledIndexes.value.map(item => Number(item.replace(/^No0+/, '')));
      disabledIndexes.value = result.filter(item => !ids.includes(item));
      addedData.value = []
      addedNum.value = 0
    }
    return {
      disabledIndexes,
      addedData,
      addedNum,
      drawerVisible,
      selectId,
      filterNum,
      dialogImport,
      keyId,
      list,
      searchForm,
      showAll,
      dialog,
      editFormData,
      type,
      allNum,
      selectPage,
      word,
      exportLoading,
      importLoading,
      listLoading,
      untaxedAmount,
      taxedAmount,
      searchFormRef,
      submitLoading,
      handleClear,
      removeFromDrawer,
      handleCloseAddCart,
      addToDrawer,
      handleAddXname,
      handleSelectionChange,
      handleUpload,
      handleImportClose,
      handleExport,
      handleImport,
      handleAdd,
      pageSizeChange,
      pageCurrentChange,
      handleSubmit,
      handleClose,
      closeSearch,
      handleSearchBtn,
      handleResetBtn,
      handleEdit,
      handleDelete,
      deleteRow,

    };
  }
})
